
import React, { useState } from "react";
import { restartService } from "./controller/SettingC";
import { useCookies } from "react-cookie";
import { Button } from "@themesberg/react-bootstrap";
export default () => {

  const [cookies] = useCookies(['lottmekong'])

  const [result, setResult] = useState([])

  const restartServiceFunc = async () => {
    try {
      const response = await restartService(cookies)
      // const response = [
      //   "* lkltt.service - My Shell Script",
      //   "     Loaded: loaded (/lib/systemd/system/lkltt.service; disabled; vendor preset: enabled)",
      //   "     Active: active (running) since Thu 2025-03-06 00:07:45 +07; 12ms ago",
      //   "   Main PID: 1167214 (bash)",
      //   "      Tasks: 2 (limit: 77024)",
      //   "     Memory: 1.7M",
      //   "        CPU: 4ms",
      //   "     CGroup: /system.slice/lkltt.service",
      //   "             |-1167214 /bin/bash /root/service/lklttService.sh",
      //   "             `-1167216 /root/venv/bin/python3 /root/service/lklttService.py",
      //   "",
      //   "Mar 06 00:07:45 luckyviet25072024 systemd[1]: Started My Shell Script.",
      //   "* lklttKeno.service - Keno",
      //   "     Loaded: loaded (/lib/systemd/system/lklttKeno.service; disabled; vendor preset: enabled)",
      //   "     Active: active (running) since Thu 2025-03-06 00:07:45 +07; 9ms ago",
      //   "   Main PID: 1167219 (bash)",
      //   "      Tasks: 2 (limit: 77024)",
      //   "     Memory: 1.5M",
      //   "        CPU: 2ms",
      //   "     CGroup: /system.slice/lklttKeno.service",
      //   "             |-1167219 /bin/bash /root/service/lklttKeno.sh",
      //   "             `-1167221 /root/venv/bin/python3 /root/service/lklttKeno.py",
      //   "",
      //   "Mar 06 00:07:45 luckyviet25072024 systemd[1]: Started Keno.",
      //   "* lklttKenoBao.service - Keno Bao",
      //   "     Loaded: loaded (/lib/systemd/system/lklttKenoBao.service; disabled; vendor preset: enabled)",
      //   "     Active: active (running) since Thu 2025-03-06 00:07:45 +07; 9ms ago",
      //   "   Main PID: 1167225 (bash)",
      //   "      Tasks: 2 (limit: 77024)",
      //   "     Memory: 1.5M",
      //   "        CPU: 2ms",
      //   "     CGroup: /system.slice/lklttKenoBao.service",
      //   "             |-1167225 /bin/bash /root/service/lklttKenoBao.sh",
      //   "             `-1167227 /root/venv/bin/python3 /root/service/lklttKenoBao.py",
      //   "",
      //   "Mar 06 00:07:45 luckyviet25072024 systemd[1]: Started Keno Bao.",
      //   "* lklttMega.service - Mega",
      //   "     Loaded: loaded (/lib/systemd/system/lklttMega.service; disabled; vendor preset: enabled)",
      //   "     Active: active (running) since Thu 2025-03-06 00:07:45 +07; 8ms ago",
      //   "   Main PID: 1167230 (bash)",
      //   "      Tasks: 2 (limit: 77024)",
      //   "     Memory: 1.3M",
      //   "        CPU: 2ms",
      //   "     CGroup: /system.slice/lklttMega.service",
      //   "             |-1167230 /bin/bash /root/service/lklttMega.sh",
      //   "             `-1167232 /root/venv/bin/python3 /root/service/lklttMega.py",
      //   "",
      //   "Mar 06 00:07:45 luckyviet25072024 systemd[1]: Started Mega.",
      //   "* lklttMax3D.service - Max3D",
      //   "     Loaded: loaded (/lib/systemd/system/lklttMax3D.service; disabled; vendor preset: enabled)",
      //   "     Active: active (running) since Thu 2025-03-06 00:07:45 +07; 8ms ago",
      //   "   Main PID: 1167236 (bash)",
      //   "      Tasks: 2 (limit: 77024)",
      //   "     Memory: 1.7M",
      //   "        CPU: 2ms",
      //   "     CGroup: /system.slice/lklttMax3D.service",
      //   "             |-1167236 /bin/bash /root/service/lklttMax3D.sh",
      //   "             `-1167238 /root/venv/bin/python3 /root/service/lklttMax3D.py",
      //   "",
      //   "Mar 06 00:07:45 luckyviet25072024 systemd[1]: Started Max3D.",
      //   "* lklttMax3DPro.service - Max3D Pro",
      //   "     Loaded: loaded (/lib/systemd/system/lklttMax3DPro.service; disabled; vendor preset: enabled)",
      //   "     Active: active (running) since Thu 2025-03-06 00:07:45 +07; 8ms ago",
      //   "   Main PID: 1167242 (bash)",
      //   "      Tasks: 2 (limit: 77024)",
      //   "     Memory: 1.5M",
      //   "        CPU: 2ms",
      //   "     CGroup: /system.slice/lklttMax3DPro.service",
      //   "             |-1167242 /bin/bash /root/service/lklttMax3DPro.sh",
      //   "             `-1167245 /root/venv/bin/python3 /root/service/lklttMax3DPro.py",
      //   "",
      //   "Mar 06 00:07:45 luckyviet25072024 systemd[1]: Started Max3D Pro.",
      //   "* lklttPower.service - Power",
      //   "     Loaded: loaded (/lib/systemd/system/lklttPower.service; disabled; vendor preset: enabled)",
      //   "     Active: active (running) since Thu 2025-03-06 00:07:45 +07; 11ms ago",
      //   "   Main PID: 1167250 (bash)",
      //   "      Tasks: 2 (limit: 77024)",
      //   "     Memory: 1.1M",
      //   "        CPU: 3ms",
      //   "     CGroup: /system.slice/lklttPower.service",
      //   "             |-1167250 /bin/bash /root/service/lklttPower.sh",
      //   "             `-1167252 /root/venv/bin/python3 /root/service/lklttPower.py",
      //   "",
      //   "Mar 06 00:07:45 luckyviet25072024 systemd[1]: Started Power.",
      //   "* image.service - Image Service",
      //   "     Loaded: loaded (/lib/systemd/system/image.service; disabled; vendor preset: enabled)",
      //   "     Active: active (running) since Thu 2025-03-06 00:07:45 +07; 5ms ago",
      //   "   Main PID: 1167258 (uwsgi)",
      //   "      Tasks: 1 (limit: 77024)",
      //   "     Memory: 2.2M",
      //   "        CPU: 3ms",
      //   "     CGroup: /system.slice/image.service",
      //   "             `-1167258 /root/venv/bin/uwsgi --socket 0.0.0.0:5000 --protocol=http -w imageService:app",
      //   "",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: *** WARNING: you are running uWSGI without its master process manager ***",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: your processes number limit is 256749",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: your memory page size is 4096 bytes",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: detected max file descriptor number: 1024",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: lock engine: pthread robust mutexes",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: thunder lock: disabled (you can enable it with --thunder-lock)",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: uwsgi socket 0 bound to TCP address 0.0.0.0:5000 fd 3",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: uWSGI running as root, you can use --uid/--gid/--chroot options",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: *** WARNING: you are running uWSGI as root !!! (use the --uid flag) ***",
      //   "Mar 06 00:07:45 luckyviet25072024 uwsgi[1167258]: Python version: 3.10.12 (main, Feb  4 2025, 14:57:36) [GCC 11.4.0]",
      //   ""
      // ]
      setResult(response)
    } catch (e) {
      console.log(e)
      alert('Lỗi khi khởi động lại dịch vụ')
    }
  }

  return (
    <>
      <Button onClick={restartServiceFunc}>Khởi động lại dịch vụ</Button>
      {result.length > 0 && <div>
        <div><b>{result[0]}</b></div>
        <div style={{ color: result[1].indexOf('Loaded: loaded') > -1 ? 'green' : 'red' }}>{result[1].indexOf('Loaded: loaded') > -1 ? 'Đã khởi động' : 'Chưa khởi động'}</div>
        <div style={{ color: result[2].indexOf('Active: active (running)') > -1 ? 'green' : 'red' }}>{result[2].indexOf('Active: active (running)') > -1 ? 'Đã hoạt động' : 'Chưa hoạt động'}</div>
        <div><b>{result[11]}</b></div>
        <div><b>{result[12]}</b></div>
        <div style={{ color: result[13].indexOf('Loaded: loaded') > -1 ? 'green' : 'red' }}>{result[13].indexOf('Loaded: loaded') > -1 ? 'Đã khởi động' : 'Chưa khởi động'}</div>
        <div style={{ color: result[14].indexOf('Active: active (running)') > -1 ? 'green' : 'red' }}>{result[14].indexOf('Active: active (running)') > -1 ? 'Đã hoạt động' : 'Chưa hoạt động'}</div>
        <div><b>{result[23]}</b></div>
        <div><b>{result[24]}</b></div>
        <div style={{ color: result[25].indexOf('Loaded: loaded') > -1 ? 'green' : 'red' }}>{result[25].indexOf('Loaded: loaded') > -1 ? 'Đã khởi động' : 'Chưa khởi động'}</div>
        <div style={{ color: result[26].indexOf('Active: active (running)') > -1 ? 'green' : 'red' }}>{result[26].indexOf('Active: active (running)') > -1 ? 'Đã hoạt động' : 'Chưa hoạt động'}</div>
        <div><b>{result[35]}</b></div>
        <div><b>{result[36]}</b></div>
        <div style={{ color: result[37].indexOf('Loaded: loaded') > -1 ? 'green' : 'red' }}>{result[37].indexOf('Loaded: loaded') > -1 ? 'Đã khởi động' : 'Chưa khởi động'}</div>
        <div style={{ color: result[38].indexOf('Active: active (running)') > -1 ? 'green' : 'red' }}>{result[38].indexOf('Active: active (running)') > -1 ? 'Đã hoạt động' : 'Chưa hoạt động'}</div>
        <div><b>{result[47]}</b></div>
        <div><b>{result[48]}</b></div>
        <div style={{ color: result[49].indexOf('Loaded: loaded') > -1 ? 'green' : 'red' }}>{result[49].indexOf('Loaded: loaded') > -1 ? 'Đã khởi động' : 'Chưa khởi động'}</div>
        <div style={{ color: result[50].indexOf('Active: active (running)') > -1 ? 'green' : 'red' }}>{result[50].indexOf('Active: active (running)') > -1 ? 'Đã hoạt động' : 'Chưa hoạt động'}</div>
        <div><b>{result[59]}</b></div>
        <div><b>{result[60]}</b></div>
        <div style={{ color: result[61].indexOf('Loaded: loaded') > -1 ? 'green' : 'red' }}>{result[61].indexOf('Loaded: loaded') > -1 ? 'Đã khởi động' : 'Chưa khởi động'}</div>
        <div style={{ color: result[62].indexOf('Active: active (running)') > -1 ? 'green' : 'red' }}>{result[62].indexOf('Active: active (running)') > -1 ? 'Đã hoạt động' : 'Chưa hoạt động'}</div>
        <div><b>{result[71]}</b></div>
        <div><b>{result[72]}</b></div>
        <div style={{ color: result[73].indexOf('Loaded: loaded') > -1 ? 'green' : 'red' }}>{result[73].indexOf('Loaded: loaded') > -1 ? 'Đã khởi động' : 'Chưa khởi động'}</div>
        <div style={{ color: result[74].indexOf('Active: active (running)') > -1 ? 'green' : 'red' }}>{result[74].indexOf('Active: active (running)') > -1 ? 'Đã hoạt động' : 'Chưa hoạt động'}</div>
        <div><b>{result[83]}</b></div>
        <div><b>{result[84]}</b></div>
        <div style={{ color: result[85].indexOf('Loaded: loaded') > -1 ? 'green' : 'red' }}>{result[85].indexOf('Loaded: loaded') > -1 ? 'Đã khởi động' : 'Chưa khởi động'}</div>
        <div style={{ color: result[86].indexOf('Active: active (running)') > -1 ? 'green' : 'red' }}>{result[86].indexOf('Active: active (running)') > -1 ? 'Đã hoạt động' : 'Chưa hoạt động'}</div>
      </div>}
    </>
  );
};
